export default __webpack_public_path__ + "static/media/barchart-with-shadow.7ea5a783.png";